import { IPage } from '../../repositories/chats/entities/synchronization/Page';
import { ITypedReduxAction } from '../../types/redux/actionType';
import { TSubAgent } from '../../types/subAgent';

export enum ESubAgentsActionTypes {
  SetPending = 'subAgents/setPending',
  SetSucceed = 'subAgents/setSucceed',
  SetFailed = 'subAgents/setFailed',
  SetSearch = 'subAgents/setSearch',
}

export type TSubAgentsSearchPayload = {
  search?: string;
};

export type TSubAgentsPayload = {
  page: IPage;
  subAgentsList: TSubAgent[];
};

export type TSubAgentsActions =
  | ITypedReduxAction<ESubAgentsActionTypes.SetPending, void>
  | ITypedReduxAction<ESubAgentsActionTypes.SetSucceed, TSubAgentsPayload>
  | ITypedReduxAction<ESubAgentsActionTypes.SetFailed, void>
  | ITypedReduxAction<ESubAgentsActionTypes.SetSearch, TSubAgentsSearchPayload>;
